const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['legacy-id-redirect'] = require('../middleware/legacy-id-redirect.js')
middleware['legacy-id-redirect'] = middleware['legacy-id-redirect'].default || middleware['legacy-id-redirect']

export default middleware
